import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable, LinkedInput } from 'components/basic'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import FlowView from 'components/core/FlowView'
import Datetime from 'react-datetime'
import { notify } from 'helpers'
import http from 'API/http'

class AccessWizard extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      updated: Date.now(),
      tabIndex: 0,
      searchQuery: '',
      customerQuery: '',
      accesses: [],
      customers: [],
      access: null,
      activate: [],
      timer: null,
      customer: {
        firstName: 'Test',
        lastName: 'Testsson',
        socialSecurityNumber: '0000000001',
        email: '',
        phone: '',
        mobilePhone: ''
      }
    }
  }
  async componentDidMount () {
    if (this.props.match.params.accessId) {
      await this.selectAccess({
        accessId: this.props.match.params.accessId
      })
      if (this.props.match.params.service && this.props.match.params.service !== 'null') {
        this.activateService({
          service: window.atob(this.props.match.params.service)
        })
      }
    }
    if (this.props.match.params.customer) {
      var err, res
      [err, res] = await http.get('2.3/customers/' + this.props.match.params.customer)
      if (err) return
      this.setState({customer: {...this.state.customer, ...res.data}})
    }
  }
  isDateValid (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }
  async searchAccess () {
    this.setState({searching: true})
    clearTimeout(this.state.search)
    this.state.search = setTimeout(async () => {
      var err, res
      [err, res] = await http.get('2.3/accesses/search/' + this.state.searchQuery)
      if (err) return this.setState({accesses: [], searching: false})
      this.setState({accesses: res.data, searching: false})
    }, 250)
  }
  async selectAccess (access) {
    var err, res
    [err, res] = await http.get('2.3/accesses/' + access.accessId)
    if (err) return notify.warn('Could not load access')

    this.setState({access: res.data, tabIndex: 1, activate: []})
  }
  selectCustomer (customer) {
    this.setState({customer: Object.assign({}, customer), updated: Date.now()})
  }
  activateService (service) {
    ReactDOM.findDOMNode(this.selected).scrollIntoView()
    if (this.state.activate.map(s => s.service).indexOf(service.service) !== -1) return
    this.setState({activate: [...this.state.activate, {...service, activationDate: Datetime.moment()}]})
  }
  deactivateService (service) {
    var index = this.state.activate.map(s => s.service).indexOf(service.service)
    if (index === -1) return
    this.state.activate.splice(index, 1)
    this.forceUpdate()
  }
  async enableService (service) {
    //eslint-disable-next-line
    var err, res
    [err, res] = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: service.service,
      activationDate: service.activationDate.unix(),
      operation: 'ACTIVATE',
      forcedTakeover: false,
      equipment: [
        { vendorId: 'CH_BROADBAND' }
      ],
      spReference: '',
      customer: this.state.customer,
      deliveryAddress: {
        smsNotificationPhone: this.state.customer.mobilePhone,
        streetName: this.state.access.streetName,
        streetNumber: this.state.access.streetNumber,
        streetLittera: this.state.access.streetLittera,
        zipCode: this.state.access.postalCode,
        city: this.state.access.city
      }
    })
    if (err) {
      service.error = true
      this.forceUpdate()
      if (err.response.data.cause) {
        var match = err.response.data.cause.match(/\[(.+?)\]/)
        if (match && match.length > 1) {
          notify.alert(match[1], service.service, 'error')
        } else {
          notify.alert(err.response.data.cause, service.service, 'error')
        }
      }
      return
    }
    notify.success(service.service + ' Has been activated')
    service.done = true
    this.forceUpdate()
  }
  activateServices () {
    if (!this.state.customer.firstName || !this.state.customer.lastName || !this.state.customer.socialSecurityNumber) return notify.alert('You have to specify a customer', '', 'warning')
    this.setState({tabIndex: ++this.state.tabIndex})
    this.state.activate.map(service => this.enableService(service))
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle='Connect Service Wizard' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='play' title={(this.state.access ? `${this.state.access.streetName} ${this.state.access.streetNumber} ${this.state.access.mduApartmentNumber} ${this.state.access.mduDistinguisher}` : 'Select Access')}>
            <Tabs selectedTabClassName='active' selectedIndex={this.state.tabIndex}>
              <div className='center-tabs'>
                <TabList className='nav nav-tabs wizard-tabs'>
                  <div className='tab-line' />
                  <Tab>
                    <a data-tip='Access'><i className={'fa fa-fw fa-home ' + (this.state.tabIndex > 0 ? 'success' : '')} /></a>
                  </Tab>
                  <Tab>
                    <a data-tip='Service(s)'><i className={'fa fa-fw fa-cog ' + (this.state.tabIndex > 1 ? 'success' : '')} /></a>
                  </Tab>
                  <Tab>
                    <a data-tip='Finalize'><i className={'fa fa-fw fa-play ' + (this.state.tabIndex > 3 ? 'success' : '')} /></a>
                  </Tab>
                </TabList>
              </div>
              <TabPanel className='tab-pane col-md-12'>
                <label>Search for Access {this.state.searching && <i className='fa fa-spin fa-spinner' />}</label>
                <LinkedInput context={this} placeholder='Search' path='searchQuery' onChange={e => this.searchAccess()} />
                <hr />
                <FlowTable data={this.state.accesses.map(res => [{ onClick: e => this.selectAccess(res) }, <a className='table-link'><i className='fa fa-play' /></a>, `${res.streetName} ${res.streetNumber} ${res.streetLittera}`, res.mduApartmentNumber, res.mduDistinguisher, `${res.postalCode} ${res.city}`])}>
                  <tr>
                    <th />
                    <th>Street</th>
                    <th>Apartment Number</th>
                    <th>Apartment Address</th>
                    <th>City</th>
                  </tr>
                </FlowTable>
              </TabPanel>
              <TabPanel className='tab-pane col-md-12'>
                {this.state.access &&
                <div className='row'>
                  <div className='col-md-12'>
                    <h3>Services</h3>
                    <FlowTable data={this.state.access.services.map(service => [<a onClick={e => this.activateService(service)} className='table-link'><i className='fa fa-plus' /></a>, (service.available === 'YES' ? <i className='fa fa-fw fa-check-circle text-success' /> : <i className='fa fa-fw fa-times-circle text-danger' />), service.service, service.connection])}>
                      <tr>
                        <th />
                        <th>Available</th>
                        <th>Name</th>
                        <th>Connected</th>
                      </tr>
                    </FlowTable>
                  </div>
                </div>
                }
              </TabPanel>
              <TabPanel className='tab-pane col-md-12'>
                <h2 className='text-center'>See service activation status below.</h2>
              </TabPanel>
            </Tabs>
          </StaticBox>
          {this.state.tabIndex > 0 && this.state.tabIndex < 2 &&
          <StaticBox cols={12} title='Selected Services' icon='list' ref={selected => (this.selected = selected)}>
            <div className='row'>
              <div className='col-md-12'>
                <FlowTable notResponsive data={this.state.activate.map((service, i) => [(this.state.tabIndex === 1 ? <a onClick={e => this.deactivateService(service)} className='table-link'><i className='fa fa-minus' /></a> : ''), service.service, <Datetime isValidDate={this.isDateValid} value={this.state.activate[i].activationDate || Datetime.moment().format('YYYY-MM-DD HH:mm')} onChange={date => {
                  this.state.activate[i].activationDate = date
                  this.forceUpdate()
                }} key={'picker' + window.btoa(service.service)} dateFormat={'YYYY-MM-DD'} timeFormat={'HH:mm'} renderInput={props =>
                  <div className='input-group'>
                    <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                    <input key={window.btoa(service.service)} {...props} className='form-control' />
                  </div>
                } inputProps={{disabled: this.state.tabIndex !== 1}} />])}>
                  <tr>
                    <th />
                    <th>Name</th>
                    <th>Activation</th>
                  </tr>
                </FlowTable>
              </div>
            </div>
            <div className='col-md-12'>
              <hr />
              <div className='row'>
                <div className='col-md-6'>
                  {this.state.tabIndex < 2 && <a onClick={e => this.setState({tabIndex: --this.state.tabIndex})} className='btn btn-primary pull-left'>Previous</a>}
                </div>
                <div className='col-md-6'>
                  {this.state.tabIndex < 1 && <a onClick={e => this.setState({tabIndex: ++this.state.tabIndex})} className='btn btn-primary pull-right margin-left-10'>Next</a>}
                  {this.state.tabIndex > 0 && this.state.tabIndex < 3 && <a onClick={e => this.activateServices()} className='btn btn-primary pull-right margin-left-10'>Activate Services</a>}
                </div>
              </div>
            </div>
          </StaticBox>}
          {this.state.tabIndex > 1 &&
          <StaticBox cols={12} title='Service Activation Status' icon='list'>
            <div className='row'>
              <div className='col-md-12'>
                <FlowTable data={this.state.activate.map((service, i) => [(service.done ? <i className='fa fa-fw fa-check-circle text-success' /> : (service.error ? <i className='fa fa-fw fa-times-circle text-danger' /> : <i className='fa fa-fw fa-cog fa-spin' />)), service.service, service.activationDate.format('YYYY-MM-DD HH:mm')])}>
                  <tr>
                    <th>Status</th>
                    <th>Name</th>
                    <th>Activation</th>
                  </tr>
                </FlowTable>
              </div>
            </div>
            <div className='col-md-12'>
              <hr />
              <div className='row'>
                <div className='col-sm-6'>
                  <a onClick={e => window.location.reload()} className='btn btn-primary'>Connect New Service</a>
                </div>
                <div className='col-sm-6'>
                  <a href={'/#/access/' + this.state.access.accessId} className='btn btn-primary pull-right'>Show access</a>
                </div>
              </div>
            </div>
          </StaticBox>}
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
AccessWizard = connect(state => state.siteReducer)(AccessWizard)
export default AccessWizard



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/access/wizard.js